import { stripHtmlTags } from '../utils';

const toSlug = (value) => {
    return (value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
};

const parseDate = (value) => {
    const dateValue = value ? new Date(value) : null;
    if (!dateValue || Number.isNaN(dateValue.getTime())) {
        return 'Recent Update';
    }
    return dateValue.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

const toPlainText = (value) => {
    if (typeof value === 'string') {
        return stripHtmlTags(value).trim();
    }
    if (Array.isArray(value) && value.length > 0) {
        const first = value[0];
        if (typeof first === 'string') {
            return stripHtmlTags(first).trim();
        }
        if (first && typeof first.value === 'string') {
            return stripHtmlTags(first.value).trim();
        }
        if (first && typeof first.processed === 'string') {
            return stripHtmlTags(first.processed).trim();
        }
    }
    if (value && typeof value.value === 'string') {
        return stripHtmlTags(value.value).trim();
    }
    if (value && typeof value.processed === 'string') {
        return stripHtmlTags(value.processed).trim();
    }
    return '';
};

const mapActivityItem = (post, index) => {
    const rawTitle = post.title?.[0]?.value || post.title || post.name || 'Untitled Activity';
    const rawBody = toPlainText(post.body) || toPlainText(post.content) || toPlainText(post.description);
    const descriptionText = toPlainText(post.description) || rawBody;
    const description = descriptionText.length > 200 ? `${descriptionText.substring(0, 200)}...` : descriptionText;
    const image = post.field_image?.[0]?.url || post.image || '';
    const date = parseDate(post.created?.[0]?.value || post.date || post.created);
    return {
        id: post.nid?.[0]?.value || post.id || index + 1,
        title: toPlainText(rawTitle) || 'Untitled Activity',
        description: description || 'Activity update coming soon.',
        content: rawBody || description || 'Activity update coming soon.',
        date,
        image,
        alt: post.field_image?.[0]?.alt || post.alt || '',
        author: post.author || 'Dr. Mohammed Audu Rehab Centre',
        category: post.field_tags?.[0] || post.category || 'Activities',
        slug: post.slug || toSlug(rawTitle) || `activity-${index + 1}`,
        index
    };
};

export const fetchAllBlogPosts = async () => {
    const activitiesEndpoint = 'https://api.dmaimpact.org/rehab-activities-view?_format=json';

    try {
        const response = await fetch(activitiesEndpoint);
        if (!response.ok) {
            return [];
        }
        const data = await response.json();
        if (!Array.isArray(data)) {
            return [];
        }
        const mapped = data.map(mapActivityItem).filter(Boolean);
        return mapped;
    } catch (error) {
        return [];
    }
};

const blogData = [];

export default blogData;
